export async function extractAudioMetadata(url) {
  const { parseBlob } = await import('music-metadata');
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);
  const blob = await res.blob();
  const { common, format } = await parseBlob(blob);
  return {
    title: common.title || null,
    artist: common.artist || null,
    album: common.album || null,
    trackNumber: common.track?.no || null,
    year: common.year || null,
    composer: common.composer?.[0] || null,
    narrator: common.comment?.[0] || null,
    duration: format.duration ? Math.round(format.duration) : null,
  };
}

export async function extractPhotoMetadata(url) {
  const exifr = await import('exifr');
  const data = await exifr.parse(url, {
    pick: ['DateTimeOriginal', 'GPSLatitude', 'GPSLongitude', 'Make', 'Model'],
  }).catch(() => null);
  if (!data) return {};
  return {
    dateOfEvent: data.DateTimeOriginal ? data.DateTimeOriginal.toISOString().split('T')[0] : null,
    location: data.GPSLatitude && data.GPSLongitude
      ? `${data.GPSLatitude.toFixed(5)}, ${data.GPSLongitude.toFixed(5)}`
      : null,
  };
}

export function extractVideoMetadata(url) {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.preload = 'metadata';
    video.crossOrigin = 'anonymous';
    video.onloadedmetadata = () => {
      const duration = isFinite(video.duration) ? Math.round(video.duration) : null;
      video.src = '';
      resolve({ duration, title: null });
    };
    video.onerror = () => {
      video.src = '';
      reject(new Error('Video metadata load failed'));
    };
    video.src = url;
  });
}
